<template>
    <div id="photos">
        <LightGallery
            :images = "images"
            :index = "index"
            :disable-scroll = "true"
            @close = "index = null"
            />
        <ul class="rig">
            <li
          v-for="(thumb, thumbIndex) in [
                   '/photos/thumbs/dan_8200.jpg',
                   '/photos/thumbs/dan_8201.jpg',
                   '/photos/thumbs/dan_8202.jpg',
                   '/photos/thumbs/dan_8203.jpg',
                   '/photos/thumbs/dan_8204.jpg',
                   '/photos/thumbs/dan_8205.jpg',
                   '/photos/thumbs/dan_8206.jpg',
                   '/photos/thumbs/dan_8207.jpg',
                   '/photos/thumbs/dan_8208.jpg',
                   '/photos/thumbs/dan_8209.jpg',
                   '/photos/thumbs/dan_8210.jpg',
                   '/photos/thumbs/dan_8211.jpg',
                   '/photos/thumbs/dan_8212.jpg',
                   '/photos/thumbs/dan_8213.jpg',
                   '/photos/thumbs/dan_8214.jpg',
                   '/photos/thumbs/dan_8300.jpg',
                   '/photos/thumbs/dan_8301.jpg',
                   '/photos/thumbs/dan_8302.jpg',
                   '/photos/thumbs/dan_8303.jpg',
                   '/photos/thumbs/dan_8304.jpg',
                   '/photos/thumbs/dan_8305.jpg',
                   '/photos/thumbs/dan_8306.jpg',
                   '/photos/thumbs/dan_8307.jpg',
                   '/photos/thumbs/dan_8308.jpg',
                   '/photos/thumbs/dan_8309.jpg',
                   '/photos/thumbs/dan_8310.jpg',
                   '/photos/thumbs/dan_8311.jpg',
                   '/photos/thumbs/dan_8312.jpg',
                   '/photos/thumbs/dan_8313.jpg',
                   '/photos/thumbs/dan_8314.jpg',
                   '/photos/thumbs/dan_8315.jpg',
                   '/photos/thumbs/dan_8316.jpg',
                   '/photos/thumbs/dan_8317.jpg',
                   '/photos/thumbs/danschmidt_family_1.jpg',
                   '/photos/thumbs/danschmidt_family_2.jpg'

        ]"
                    :key="thumbIndex"
                    @click="index = thumbIndex"
            >
                <img :src="thumb">
            </li>
        </ul>
    </div>


</template>

<script>
    //https://stackoverflow.com/questions/51503680/how-to-display-images-like-a-grid-in-a-div
    //https://travishorn.com/creating-a-photo-gallery-with-vue-css-grid-3e0a3dd25285
    // !! https://medium.com/swlh/creating-a-pinterest-style-image-gallery-in-vue-927836b7d173
    import { LightGallery } from 'vue-light-gallery'

    export default {
        name: "Photos",
        components: {
        LightGallery,
        },
        data: function () {
            return {
                images: [
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8200.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8201.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8202.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8203.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8204.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8205.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8206.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8207.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8208.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8209.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8210.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8211.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8212.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8213.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8214.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8300.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8301.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8302.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8303.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8304.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8305.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8306.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8307.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8308.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8309.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8310.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8311.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8312.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8313.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8314.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8315.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8316.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/dan_8317.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/danschmidt_family_1.jpg'},
                    { title: 'www.danielfieldschmidt.com', url: '/photos/danschmidt_family_2.jpg'},
                ],
                index: null

            };
        },

        computed: {},


        methods: {
        }
    }
</script>

<style>
    ul.rig {
        list-style: none;
        font-size: 0px;
    }
    ul.rig li {
        display: inline-block;
        padding: 10px;
        border: 1px solid #ddd;
        font-size: 16px;
        font-size: 1rem;
        vertical-align: top;
        box-shadow: 0 0 5px #ddd;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
</style>
